// extracted by mini-css-extract-plugin
export var base = "_25-0";
export var updateBanner = "_25-1";